export enum ValidationStep {
  AWAITING = "AWAITING",
  ELIGIBLE = "ELIGIBLE",
  NOT_ELIGIBLE = "NOT_ELIGIBLE"
}

export const getValidationStyleMap = {
  [ValidationStep.AWAITING]: {
    title: "Por favor, aguarde",
    subtitle: "Analisando proposta",
    icon: "clock",
    iconColor: "$warning400",
    bgColor: "$backgroundLightMuted",
    showPrimaryButton: false,
    showSecondaryButton: false
  },
  [ValidationStep.ELIGIBLE]: {
    title: "Elegível",
    subtitle:
      "A verificação foi concluída! Você pode prosseguir com o preenchimento da proposta de crédito.",
    icon: "check-circle",
    iconColor: "$primary600",
    bgColor: "$success0",
    showPrimaryButton: true,
    showSecondaryButton: false
  },
  [ValidationStep.NOT_ELIGIBLE]: {
    title: "Não elegível",
    subtitle:
      "A verificação foi concluída. Você pode continuar com a oferta do Cartão Fidelidade (recomendado) ou recorrer à mesa de crédito.",
    icon: "times-circle",
    iconColor: "$error600",
    bgColor: "$error00",
    showPrimaryButton: true,
    showSecondaryButton: false
  }
};
